import React from 'react';

// ── Primitives ────────────────────────────────────────────────────────────────

const pulse = 'animate-pulse';
const bar  = 'rounded bg-white/[0.07]';
const dim  = 'rounded bg-white/[0.04]';

/** Non-grouped message: avatar + username/timestamp + content lines */
const SkeletonRow: React.FC<{ lines: string[] }> = ({ lines }) => (
  <div className={`flex items-start px-4 py-0.5 mt-4 first:mt-0 ${pulse}`}>
    {/* Avatar */}
    <div className="w-10 h-10 flex-shrink-0 mr-3 rounded-full bg-white/[0.07]" />
    <div className="flex-1 min-w-0">
      {/* Username + timestamp */}
      <div className="flex items-center gap-2 mb-1.5">
        <div className={`h-3.5 w-24 ${bar}`} />
        <div className={`h-3 w-14 ${dim}`} />
      </div>
      {/* Content lines */}
      {lines.map((w, i) => (
        <div key={i} className={`h-3.5 mt-1 ${bar} ${w}`} />
      ))}
    </div>
  </div>
);

/** Grouped follow-up: timestamp spacer + single content line */
const SkeletonGrouped: React.FC<{ width: string }> = ({ width }) => (
  <div className={`flex items-start px-4 py-0.5 ${pulse}`}>
    <div className="w-10 flex-shrink-0 mr-3" />
    <div className={`h-3.5 mt-0.5 ${bar} ${width}`} />
  </div>
);

// ── Channel message skeleton ───────────────────────────────────────────────

export const ChannelMessageSkeleton: React.FC = () => (
  <div className="py-4">
    {/* Group 1 */}
    <SkeletonRow lines={['w-64', 'w-48']} />
    <SkeletonGrouped width="w-80" />
    <SkeletonGrouped width="w-40" />

    {/* Group 2 */}
    <SkeletonRow lines={['w-96']} />
    <SkeletonGrouped width="w-72" />

    {/* Group 3 — longer conversation */}
    <SkeletonRow lines={['w-72', 'w-56', 'w-32']} />
    <SkeletonGrouped width="w-52" />

    {/* Group 4 */}
    <SkeletonRow lines={['w-48']} />

    {/* Group 5 */}
    <SkeletonRow lines={['w-80', 'w-64']} />
    <SkeletonGrouped width="w-36" />
    <SkeletonGrouped width="w-60" />
  </div>
);

export const DirectMessageSkeleton: React.FC = () => (
  <div className="py-4">
    <SkeletonRow lines={['w-52', 'w-40']} />
    <SkeletonGrouped width="w-64" />
    <SkeletonRow lines={['w-72']} />
    <SkeletonGrouped width="w-48" />
    <SkeletonGrouped width="w-32" />
    <SkeletonRow lines={['w-60', 'w-44']} />
  </div>
);
